import InventoryList from './InventoryList';

const inventory =  {
    list: InventoryList,
};

export default inventory;
